import React from 'react';
import { Collapse, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { METRIC_DEFS } from '../constants';

const { Text } = Typography;

const ScoringFormulaPanel: React.FC = () => {
    const { t } = useTranslation();
    const I18N = 'dashboard.dailyMeeting';
    return (
        <Collapse
            size="small"
            defaultActiveKey={[]}
            items={[
                {
                    key: 'formula',
                    label: t(`${I18N}.formula.title`),
                    children: (
                        <div className="flex flex-col gap-1 text-xs">
                            <Text type="secondary">{t(`${I18N}.formula.overview`)}</Text>
                            <Text type="secondary">{t(`${I18N}.formula.sev`)}</Text>
                            <Text type="secondary">{t(`${I18N}.formula.burst`)}</Text>
                            <Text type="secondary">{t(`${I18N}.formula.contribution`)}</Text>
                            <div className="mt-1">
                                <Text type="secondary" strong>{t(`${I18N}.formula.metricParams`)}</Text>
                            </div>
                            <ul className="pl-4 m-0">
                                {METRIC_DEFS.map((def) => (
                                    <li key={def.key}>
                                        <Text type="secondary">
                                            {t(`${I18N}.metric.${def.i18nKey}`)}: {t(`${I18N}.formula.paramLine`, {
                                                target: def.target.toFixed(1),
                                                tolerance: def.tolerance,
                                                weight: def.weight.toFixed(3),
                                            })}
                                        </Text>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ),
                },
            ]}
        />
    );
};

export default ScoringFormulaPanel;
